'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TextArea = require('../../lib/TextArea');

var _TextArea2 = _interopRequireDefault(_TextArea);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _mergeThemeHoc = require('merge-theme-hoc');

var _mergeThemeHoc2 = _interopRequireDefault(_mergeThemeHoc);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = {
  'textAreaContainer': 'TextArea__textAreaContainer___2-d4m',
  'fieldContainer': 'TextArea__fieldContainer___2RAwF',
  'label': 'TextArea__label___2_a4i',
  'message': 'TextArea__message___30F-_',
  'error': 'TextArea__error___1jTWl',
  'errorMessage': 'TextArea__errorMessage____Xou_',
  'errorMessageRight': 'TextArea__errorMessageRight___3s91s'
};

var DefaultTextArea = (0, _mergeThemeHoc2.default)(style)(_TextArea2.default);
DefaultTextArea.displayName = 'DefaultTextArea';
exports.default = DefaultTextArea;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/dist/TextArea/index.js
// module id = ./node_modules/dibs-elements/dist/TextArea/index.js
// module chunks = 4